import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import * as styles from "./styles/banner.css"

export type BannerProps = {
  onDataLoad: () => void
}

export default function Banner({ onDataLoad }: BannerProps) {
  const { content } = useStaticQuery(graphql`
    query MarketingBannerContent {
      content: contentfulMarkdownContent(name: { eq: "Marketing Banner" }) {
        heading
        body {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  `)

  React.useEffect(() => {
    if (content) {
      onDataLoad()
    }
  }, [content])

  if (!content) return null

  return (
    <div className={styles.root}>
      <div className={styles.badge}>{content.heading}</div>
      <div
        className={styles.body}
        dangerouslySetInnerHTML={{
          __html: content.body?.childMarkdownRemark?.html,
        }}
      />
    </div>
  )
}
